<div class="fieldset-wrapper" [ngClass]="(questions?.mandatory && isMandatoryUpfront) || (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid) ? 'isMandatory' : ''">
  <!-- <div *ngIf="questions?.hasMedia && questions?.QuestionMedias_1 != null" class="questionImageWrapper">
    <app-question-media [questionMedias]="questions?.QuestionMedias_1" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-media>
  </div>
  <div *ngIf="questions?.hasImages && questions?.QuestionImages_1.length > 0" class="questionImageWrapper">
    <app-question-images [questionImages]="questions?.QuestionImages_1" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-images>
  </div> -->

  <div *ngIf="questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper" [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>
  <fieldset [attr.aria-required]="isAriaRequired">
    <legend class="question-option-wrapper" [ngClass]="{'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile}">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
      </span>
      <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span>
      <span *ngIf="questions.piping"
      [ngClass]="{'question-text' : questions?.isOverAllStyleApplied,
      'question-text-nb': !questions?.isOverAllStyleApplied,
      'no-Qno':!isDisplayQno}"
        id="lbltitle_CS{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
        <div class="constraint-msg-wrapper">
          <div [hidden] ="!(questions?.constraintType > 0 && questions?.constraintNum > 0 && questions?.isAlertDanger)"
              [ngClass]="(questions?.isAlertDanger) ? 'q-title-txt inst-txt-style constraint-error-msg': 'q-title-txt inst-txt-style'">
              [{{questions?.error_msg}}]
            </div>
          </div>
      </span>
      <span *ngIf="!questions.piping"
      [ngClass]="{'question-text' : questions?.isOverAllStyleApplied,
      'question-text-nb': !questions?.isOverAllStyleApplied,
      'no-Qno':!isDisplayQno}"
        id="lbltitle_CS{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
          <div *ngIf="questions?.hasMedia && questions?.MediaText != null && questions?.MediaText != ''" class="question-media-text">
            <span>[{{questions?.MediaText}}]</span>
          </div>
          <div class="constraint-msg-wrapper">
            <div [hidden] ="!(questions?.constraintType > 0 && questions?.constraintNum > 0 && questions?.isAlertDanger)"
              [ngClass]="(questions?.isAlertDanger) ? 'q-title-txt inst-txt-style constraint-error-msg': 'q-title-txt inst-txt-style'">
              [{{questions?.error_msg}}]
            </div>
          </div>
      </span>
      <span *ngIf="isAriaRequired && isMobile" class="screen-reader-only">This Question is Required</span>
    </legend>
    <!-- <div *ngIf="questions?.hasMedia && questions?.QuestionMedias_2 != null" class="questionImageWrapper">
      <app-question-media [questionMedias]="questions?.QuestionMedias_2" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-media>
    </div>
    <div *ngIf="questions?.hasImages && questions?.QuestionImages_2.length > 0" class="questionImageWrapper">
      <app-question-images [questionImages]="questions?.QuestionImages_2" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-images>
    </div> -->

    <div *ngIf="questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <ng-container *ngIf="!isDisplayedPipeMessage;else answerPipeMessage">
    <div class="fieldset-wrapper-scroll-cont">
      <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
      <div class="fieldset-wrapper-scroll">
        <div style="display: table; width: 100%;" class="answerParent">
          <div class="answer-option-wrapper na-box" [attr.data-ans-image]="answerImagesLength">
            <div *ngIf="questions.qsubtype == 0">
              <div *ngIf="questions.population_type != 3; else PreReadPopulation">
                <div *ngIf="!isMobile else SingleColumnCode">
                  <div *ngIf="questions?.DispAnsCol > 1; else SingleColumnCode">
                    <div>
                      <div>
                        <div
                          [ngClass]="(questions?.DispAnsCol==2 ? 'twoColumns': (questions?.DispAnsCol==3 ? 'threeColumns': (questions?.DispAnsCol==4 ? 'fourColumns' : 'fiveColumns')))"
                          *ngFor="let answers of answersArray; let i = index">
                          <table style="width: 100%;" cellpadding="0" cellpadding="3" class="main-hrb-cont"
                            role="presentation" id="{{questions?.UniqueNumber}}_na_table">
                            <tr class="" *ngFor="let answer of answers; let j = index"
                             [ngClass]="{'': (j == answers.length - 1) && (j == answers.length - 1 ? getAnswerInvalid(answers[j]): 'false')}">
                              <!-- it shows horizontal and vertical data-->
                              <td *ngFor="let ans of answer" class="answer-option radio-hrb"
                                style="width: auto; padding: 0px; margin: 0px; background-color: transparent; cursor: default;"
                                [style.width]="columnWidth + '%'">
                                <div class="transparent-brdr-rght">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" class="scrollMain"
                                    role="presentation">
                                    <tr>
                                      <td style="width: 1%;">
                                        <!-- <app-answer-media [AnswerMedias]="ans?.AnswerMedias"></app-answer-media>
                                        <app-answer-images [AnswerImages]="ans?.AnswerImages"></app-answer-images> -->
                                        <!-- <div *ngFor="let ansImage of ans?.AnswerImages;" class="answer-opt-image">
                                          <div>
                                            <app-image-control [imageName]="ansImage?.imageName" [imageURL]="ansImage?.imageURL">
                                            </app-image-control>
                                          </div>
                                        </div> -->
                                      </td>
                                      <td>
                                        <label
                                          for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{ans.value_id}}_ID"
                                          class="a-strip a-strip-na na-tb-space"
                                          style="display: table-cell;">
                                          <!-- <span class="radio-btn structure"></span> -->
                                          <span class="answer-text answer-text-hrb"
                                            style="margin-left: 0px; margin-right: 0px; padding-right: 0px; min-width: auto; width: auto; word-break: normal; cursor: default;" [innerHTML]="ans.value_text  | headerFooterHtml"></span>
                                        </label>
                                        <div style="display: table-cell;">
                                          <div style="position: relative;">
                                          <input type="text" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_NAME"
                                            id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{ans.value_id}}_ID" value="{{ans.value_text}}"
                                            [(ngModel)]="ans.ControlAns" (blur)="NumberValidation($event, $event.target.value, ans)"
                                            attr.aria-labelledby="lbltitle_CS{{questions?.UniqueNumber}}" [ngClass]="{'red-zone': ans.isValid}"
                                            style="padding: 3px 15px; width: 100%;" [attr.aria-label]="answers.value_text" (keydown)="keyDown($event)" />
                                          <div [hidden]="!(questions.isValid && ans.isValid)" class="validator_message" role="alert">
                                            {{surveyMessages.strinvalidvaluemsg}}
                                          </div>
                                        </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <tr *ngIf="questions?.constraintType > 0">
                              <td class="answer-option radio-hrb" style="padding: 0px; background-color: transparent; cursor: default;">
                                <div class="transparent-brdr-rght">
                                  <table class="hrb-table" cellpadding="0" cellpadding="0" class="scrollMain"
                                    role="presentation">
                                    <tr>
                                      <td style="width: 1%;">
                                      </td>
                                      <td>
                                        <label class="a-strip a-strip-na na-tb-space"
                                          style="display: table-cell;" for="{{questions?.UniqueNumber}}_txt_total">
                                          <div class="na-total"><span class="na-total1">{{TotalText}}</span></div></label>
                                        <div style="display: table-cell;">
                                          <div style="position: relative;">
                                          <input type="text" class="na-textbox" id="{{questions?.UniqueNumber}}_txt_total" [(ngModel)]="questions.otherAnswer" readonly
                                            aria-label="Total" />
                                            <!-- <div [hidden]="!(questions.isValid && questions.isAlertDanger)" class="validator_message">
                                                {{questions.error_msg}}
                                              </div> -->
                                            </div>
                                          </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>

                        <div *ngIf="isNgOnChange"> {{ngAfterContentHandle()}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <ng-template #SingleColumnCode>
                  <!-- [ngClass]="(answers?.hasImage && answers?.AnswerImages.length == 1) ? 'single-ans-image' : (answers?.hasImage && answers?.AnswerImages.length == 2)? 'multi-ans-image': '' " -->
                  <div class="na-tb-space" *ngFor="let answers of questions?.Answers; let i = index"
                    [ngClass]="getAnsImageMediaCSS(answers)">
                    <div [hidden]="answers?.isHide || answers?.isADLHide">
                      <div class="a-strip a-strip-na na-tb-space" [ngClass]="{'a-strip-bottom': (i == questions.Answers.length - 1) && answers.isValid}">
                        <label for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{answers?.value_id}}_ID"
                          [ngClass]="(answers.ControlAns) ? 'selectedAnsOpt': ''">
                          <span class="na-tb-space"  [innerHTML]="answers.value_text | headerFooterHtml"></span>
                        </label>
                        <div style="display: inline-block; position: relative;">
                          <input type="text" [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_CS_NAME'"
                            id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{answers?.value_id}}_ID" value="{{answers.value_text}}"
                            [(ngModel)]="answers.ControlAns" (blur)="NumberValidation($event, $event.target.value, answers)"
                            #numericValidation="ngModel" class="na-textbox" [attr.aria-label]="answers.value_text"
                            [ngClass]="{'red-zone': answers.isValid}" (keydown)="keyDown($event)" />
                          <div [hidden]="!(questions.isValid && answers.isValid)" class="validator_message" role="alert">
                            {{surveyMessages.strinvalidvaluemsg}}
                          </div>
                        </div>
                      </div>
                      <!-- *ngIf="answers?.hasImage" -->
                      <!-- <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                      <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images> -->
                      <span class="na-tb-space"></span>
                    </div>
                  </div>
                  <div *ngIf="questions?.constraintType > 0" class="a-strip a-strip-na na-tb-space">
                    <label for="{{questions?.UniqueNumber}}_txt_total">{{TotalText}}</label>
                    <div style="display: inline-block; position: relative;">
                      <input type="text" id="{{questions?.UniqueNumber}}_txt_total" [(ngModel)]="questions.otherAnswer" readonly
                        class="na-textbox" aria-label="Total" />
                      <!-- <div [hidden]="!(questions.isValid && questions.isAlertDanger)" class="validator_message">
                        {{questions.error_msg}}
                      </div> -->
                    </div>
                  </div>
                  <div *ngIf="isNgOnChange"> {{ngAfterContentHandle()}}</div>
                </ng-template>
              </div>
              <ng-template #PreReadPopulation>
                <!-- [ngClass]="(answers?.hasImage && answers?.AnswerImages.length == 1) ? 'single-ans-image' : (answers?.hasImage && answers?.AnswerImages.length == 2)? 'multi-ans-image': '' " -->
                <div class="na-tb-space" *ngFor="let answers of questions?.Answers; let i = index"
                  [ngClass]="getAnsImageMediaCSS(answers)">
                  <div [hidden]="answers?.isHide || ans?.isADLHide">
                    <div class="a-strip a-strip-na na-tb-space">
                      <label for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{answers?.value_id}}_ID"
                        [ngClass]="(answers.ControlAns) ? 'selectedAnsOpt': ''">
                        <span class="na-tb-space" [innerHTML]="answers.value_text  | headerFooterHtml"></span>
                      </label>
                      <div style="display: inline-block; position: relative;">
                        <input type="text" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_NAME"
                          id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_CS_{{answers?.value_id}}_ID"
                          value="{{answers.value_text}}" [(ngModel)]="answers.ControlAns"
                          (blur)="NumberValidation($event, $event.target.value, answers)" (keyup)="range = false;"
                          #numericValidation="ngModel" class="na-textbox"
                          attr.aria-labelledby="lbltitle_CS{{questions?.UniqueNumber}}" [ngClass]="{'red-zone':answers.isValid}"
                          [attr.aria-label]="answers.value_text" (keydown)="keyDown($event)" />
                        <div [hidden]="!(questions.isValid && answers.isValid)" class="validator_message" role="alert">
                          {{surveyMessages.strinvalidvaluemsg}}
                        </div>
                      </div>
                    </div>

                    <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                    <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>

                    <span class="radio-btn structure"></span>
                    <span class="answer-text" [innerHTML]="answers.value_text  | headerFooterHtml"></span>
                  </div>
                  <div *ngIf="questions?.constraintType > 0" class="a-strip a-strip-na na-tb-space">
                    <label for="{{questions?.UniqueNumber}}_txt_total">{{TotalText}}</label>
                    <div style="display: inline-block; position: relative;">
                      <input type="text" id="{{questions?.UniqueNumber}}_txt_total" readonly aria-label="Total" />
                      <div [hidden]="!(questions.isValid && questions.isAlertDanger)" class="validator_message" role="alert">
                        {{questions.error_msg}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
            <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
              <div  class="ques-response-btn-div">
                <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
                  (click)="gotoNextQuestion(questions,$event.target)" /> -->
                  <button *ngIf="showNewParticipationButton && isAnsChange" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    </ng-container>

    <ng-template #answerPipeMessage>
      <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
    </ng-template>
  </fieldset>
</div>
